<script>
  export let item;
</script>

<div class="link-item">
  <h5 class="link-item__title">{item.title}</h5>
  {#each item.links as link}
    {#if link.url}
      <a class="link-item__link text-link text-small" href={link.url}
        ><span>{link.text}</span></a
      >
    {:else}
      <p class="link-item__link text-small">
        {link.text}
      </p>
    {/if}
  {/each}
</div>

<style lang="scss">
  .link-item {
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // width: 32.5rem;
    padding: 3rem 1rem 3rem 6rem;

    @include resp-max('s') {
      align-items: center;
      padding: 3rem 6rem;
      text-align: center;
    }

    &__title {
      margin-bottom: 1rem;

      @include resp-max('xs') {
        font-size: 2.4rem;
      }
    }

    &__link {
      margin-top: 1rem;
      color: var(--royal-light);
    }
  }
</style>
